var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3501_27029)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0405273,
    width: 16.9185,
    height: 16.9185,
    rx: 2.70696,
    fill: "#F0FFF1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3501_27029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.34802 8.50023L7.28527 11.4375L13.1598 5.56299",
    stroke: "#0E8345",
    strokeWidth: 1.35348,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3501_27029"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0405273,
    width: 16.9185,
    height: 16.9185,
    rx: 2.70696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3501_27029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0988,
    height: 14.0988,
    fill: "white",
    transform: "translate(1.4104 1.44922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.6f3e840c2fc475f82712bf7c2fa23669.svg";
export { ForwardRef as ReactComponent };